module.exports = __webpack_public_path__ + "static/media/extentPolicy.3ecf65f1.svg";